<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link href="https://www.facebook.com/jinmataicargo/" class="brand-logo" >
        <!-- <vuexy-logo /> -->
        <b-img
          class="d-none d-sm-block"
          :src="require('@/assets/logo-taobao/Profile.jpg')"
          fluid
          width="50px"
          height="30px"
        >
        </b-img>
        <h2 class="brand-text text-primary ml-1 mt-1 d-none d-sm-block">
          JINMATAICARGO
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            :src="imgUrl"
            fluid
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            <h1 class="">กู้รหัสผ่าน🔒</h1>
          </b-card-title>

          <!-- form -->
          <validation-observer ref="simpleRules" #default="{invalid}">
            <b-form
              class="auth-reset-password-form mt-2"
              method="POST"
              @submit.prevent="setNewPassword"
            >
              <!-- username -->
              <b-form-group
                label="Username :"
                label-for="reset-password-new"
              >
                <h4 class="">{{username}}</h4>
              </b-form-group>

              <!-- password -->
              <b-form-group
                label="รหัสผ่านใหม่ :"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small v-if="valPassword == false && errors[0] == null" class="text-danger">รหัสผ่านไม่ตรงกัน</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                label="ยืนยันรหัสผ่าน :"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="confirmPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
                :disabled="invalid"
              >
                ตั้งรหัสผ่านใหม่
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login-v2'}">
              <feather-icon icon="ChevronLeftIcon" /> เข้าสู่ระบบ
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton, BImg,
} from 'bootstrap-vue'
import { required } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {header_token, token_api} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      valPassword: true,
      code: '',
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    this.resetPassword()
  },
  watch: {
    password() {
      if ( this.password == this.rePassword ) {
        this.valPassword = true
      }
    },
    confirmPassword() {
      if ( this.confirmPassword == this.password ) {
        this.valPassword = true
      }
    }
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    async resetPassword() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const code = await urlParams.get('code')
      this.code = code

      let response = await axios.get(
        taobaoService_dotnet + '/app/Customer/get-user-from-forget-password?code=' + code,
        { headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer '+ token_api }}
      );
      if ( response.data.status == 'success' ) {
        this.username = response.data.username
      } else {
        console.log("ไม่พบข้อมูล link wrong");
      }
    },
    async setNewPassword() {
      var keepdata = []
      if ( this.password != this.confirmPassword ) {
        this.valPassword = false
      } else if ( this.password == this.confirmPassword ) {
        var axios = require('axios');
        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'app/Customer/update-user-credential-from-forget-password?code=' + this.code + '&Credential=' + this.password,
          headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
          },
        };

        await axios(config)
        .then(function (response) {
          keepdata = response.data
        })
        .catch(function (error) {
          console.log(error);
        });

        if ( keepdata.status == 'success') {
          this.$bvToast.toast('เปลี่ยนรหัสผ่านใหม่เรียบร้อย ระบบจะทำการเปลี่ยนเส้นทางไปหน้า log in', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true,
          })
          setTimeout(() => this.$router.push({ path: '/login'}), 3000);
        } else {
          this.$bvToast.toast('กรุณาตรวจสอบ Link จาก Email อีกครั้ง', {
            title: 'ไม่สำเร็จ',
            variant: 'danger',
            solid: true,
          })
        }
      }
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
